// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ImageSizeFragmentDoc = gql`
    fragment imageSize on ImageSize {
  url
  sources {
    url
    mimeType
  }
}
    `;